import type { ShellSidebarMenuEntry } from '@enacom/ui';
import { APP_DEFAULT_INTERNAL_PATH } from '../app-routing.constants';

/** Configuração de navegação lateral + metadados de marca (por produto / ambiente). */
export interface AppBaseConfig {
  brandName: string;
  /**
   * Caminho servido em `/assets` (assets base vêm de `apps/base-platform/public/assets`).
   */
  logoPath: string;
  logoMiniPath: string;
  menu: ShellSidebarMenuEntry[];
}

export const INTERNAL_NAVIGATION: AppBaseConfig = {
  brandName: 'Plataforma de experimentação',
  logoPath: '/assets/logos/digital-twin-powerhouser.png',
  logoMiniPath: '/assets/logos/enacom_logo_mini.svg',
  menu: [
    {
      type: 'item',
      id: 'experiments',
      label: 'Experimentos',
      pageTitle: 'Experimentos',
      route: `/${APP_DEFAULT_INTERNAL_PATH}`,
      icon: 'experiment',
    },
    {
      type: 'item',
      id: 'compare',
      label: 'Comparador',
      pageTitle: 'Comparador',
      route: '/compare',
      icon: 'swap',
    },
  ],
};

/** Compat: apenas o array de itens do menu. */
export const INTERNAL_NAVIGATION_CONFIG = INTERNAL_NAVIGATION.menu;
